import { useContext, createContext, useState, useEffect } from "react";
import api from "../config/api";

const ContextAPI = createContext({});

const userToken = localStorage.getItem("@Reservei:token");
const userId = localStorage.getItem("@Reservei:userId");
const userEstablishment = localStorage.getItem("@Reservei:userEstablishment");
const userCategory = localStorage.getItem("@Reservei:userCategory");
const isPetEstablishment =
  localStorage.getItem("@Reservei:userCategory") === localStorage.getItem("@Reservei:establishmentPetId");
const isFashionEstablishment =
  localStorage.getItem("@Reservei:userCategory") === localStorage.getItem("@Reservei:establishmentFashionId");
const isFoodEstablishment =
  localStorage.getItem("@Reservei:userCategory") === localStorage.getItem("@Reservei:establishmentFoodId");
const isBeautyEstablishment =
  localStorage.getItem("@Reservei:userCategory") === localStorage.getItem("@Reservei:establishmentBeautyId");
const isDrugStoreEstablishment =
  localStorage.getItem("@Reservei:userCategory") === localStorage.getItem("@Reservei:establishmentDrugStoreId");
const isRecreationEstablishment =
  localStorage.getItem("@Reservei:userCategory") === localStorage.getItem("@Reservei:establishmentRecreationId");

export const ContextProvider = ({ children }) => {
  const [service, setService] = useState("");
  const [product, setProduct] = useState("");

  const getTypes = async () => {
    try {
      const types = await api.get("/type");
      if (types.data.length) {
        types.data.forEach((type) => {
          console.log();
          if (type.name === "service") setService(() => type._id);
          if (type.name === "product") setProduct(() => type._id);
        });
      }
    } catch (error) {
      console.log("getTypes ContextAPI error", error.message);
    }
  };
  useEffect(() => {
    getTypes();
  }, []);

  return (
    <ContextAPI.Provider
      value={{
        userToken,
        userId,
        userEstablishment,
        isPetEstablishment,
        isFashionEstablishment,
        isRecreationEstablishment,
        isFoodEstablishment,
        isBeautyEstablishment,
        isDrugStoreEstablishment,
        userCategory,
        service,
        product,
      }}
    >
      {children}
    </ContextAPI.Provider>
  );
};

export const useAuth = () => useContext(ContextAPI);
